module.exports = __webpack_public_path__ + "img/vector.7b95047a.svg";